import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../components/ui/alert-dialog';
import { Trash2 } from 'lucide-react';

type DeleteSessionConfirmDialogProps = {
  open: boolean;
  sessionName: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function DeleteSessionConfirmDialog({
  open,
  sessionName,
  onConfirm,
  onCancel,
}: DeleteSessionConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen: boolean) => !isOpen && onCancel()}>
      <AlertDialogContent data-testid="delete-session-confirm-dialog">
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-destructive/10 text-destructive">
              <Trash2 className="h-5 w-5" />
            </div>
            <AlertDialogTitle>Delete session?</AlertDialogTitle>
          </div>
        </AlertDialogHeader>

        <AlertDialogDescription asChild>
          <div className="space-y-3">
            <p>
              Delete session <strong>&quot;{sessionName || 'Untitled Session'}&quot;</strong>?
            </p>
            <p className="text-muted-foreground text-sm">
              This will permanently remove the session from your Sessions list. This action cannot be undone.
            </p>
          </div>
        </AlertDialogDescription>

        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid="delete-session-cancel">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive-fill text-destructive-foreground hover:bg-destructive-fill/90"
            data-testid="delete-session-confirm"
          >
            Delete Session
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

